import {
    Component,
    ElementRef,
    Inject,
    OnInit,
    ViewChild,
    ViewEncapsulation,
} from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import * as bcrypt from "bcryptjs";
import { RecordAction } from "../../../../../../utils/enums/shared/enums";
import { SmsService } from "../../../../../../services/sms/sms.service";
import { AuthenticationService } from "../../../../../../services/security/authentication.service";
import { SharedCatalogService } from "../../../../../../services/shared/sharedcatalog.service";
import { ShortCode } from "../../../../../../utils/types/shared/shortcode.type";
import { GruposService } from "../../../../../../services/groups/grupos.service";
import { Grupo } from "../../../../../../utils/types/groups/grupo.type";
import { SmsInstantDTO } from "../../../../../../utils/types/sms/smsInstantDTO.type";
import { TranslateService } from "@ngx-translate/core";
import { SMSTemplate } from "../../../../../../utils/types/sms/sms-template.type";
import { SmsTemplateService } from "../../../../../../services/sms/sms-template.service";
import { MatSelectChange } from "@angular/material/select";
import { isArray } from "lodash";

@Component({
    selector: "wtf-sms-form",
    templateUrl: "./sms-form.component.html",
    styleUrls: ["./sms-form.component.scss"],
    providers: [
        SmsService,
        AuthenticationService,
        SharedCatalogService,
        GruposService,
        SmsTemplateService,
    ],
    encapsulation: ViewEncapsulation.None,
})
export class SmsFormComponent implements OnInit {
    @ViewChild("searchInput") input: ElementRef<HTMLInputElement>;

    smsModel: SmsInstantDTO;
    dialogTitle: string;
    smsForm: FormGroup;
    action: RecordAction;
    callback: (sms) => void;

    hideMessage = false;
    isWaiting = false;
    hasURL: boolean;
    templateSelected = true;
    shortCodes: ShortCode[];
    grupos: Grupo[];
    operators: any;
    smsType: string;
    // presetColors = MatColors.presets;
    recordAction = RecordAction;

    smsTemplates: SMSTemplate[] = [];
    smsFilteredTemplates: SMSTemplate[] = [];

    constructor(
        public dialogRef: MatDialogRef<SmsFormComponent>,
        @Inject(MAT_DIALOG_DATA) private data: any,
        private sharedCatalog: SharedCatalogService,
        private translateService: TranslateService,
        private smsTemplateService: SmsTemplateService
    ) {
        this.translateService.setDefaultLang("en");
        this.translateService.use(localStorage.getItem("language") || "en");
        this.smsModel = data.sms;
        this.action = data.action;
        this.shortCodes = data.shortCodes;
        this.callback = data.callback;

        if (
            this.action === RecordAction.Update ||
            this.action === RecordAction.View
        ) {
            this.dialogTitle = "Campaña SMS";
            this.dialogTitle + this.translateService.instant(this.dialogTitle);
            this.smsType = data.sms.type;
        } else {
            this.dialogTitle = "Enviar Mensaje";
            this.dialogTitle = this.translateService.instant(this.dialogTitle);
            this.smsModel = new SmsInstantDTO();
        }

        this.smsForm = this.createForm();
        this.loadTemplates();

        if (this.action === this.recordAction.View) {
            this.smsForm.controls["grupo"].disable();
            this.smsForm.controls["shortcode"].disable();
        }
    }

    ngOnInit() {
        document.addEventListener(
            "keydown",
            (e) => {
                if (
                    (e.target as any).nodeName === "MAT-SELECT" ||
                    (e.target as any).nodeName === "INPUT"
                ) {
                    e.stopImmediatePropagation();
                }
            },
            true
        );
    }

    loadTemplates() {
        this.smsTemplateService
            .getTemplates({ onlyactives: true })
            .subscribe((res) => {
                this.smsTemplates = res.rows;
                this.smsFilteredTemplates = this.smsTemplates;
            });
    }

    onKey(event) {
        this.smsFilteredTemplates = this.search(event.value);
    }

    search(value: string) {
        let filter = value.toLowerCase();
        return this.smsTemplates.filter((option) =>
            option.name.toLowerCase().startsWith(filter)
        );
    }

    onSelect(event: MatSelectChange) {
        this.input.nativeElement.value = "";
        this.smsFilteredTemplates = this.smsTemplates;

        let template = event.value as SMSTemplate;
        this.smsForm.controls["grupo"].setValue(template.groups);
        this.smsForm.controls["message"].setValue(template.content);
        this.smsForm.controls["shortcode"].setValue(template.shortCode);

        if (template.url_code !== null && template.url_code !== "") {
            this.smsForm.controls["longUrl"].setValue(template.url_code);
            this.hasURL = true;
        }

        this.smsModel.template_id = template.id;
        this.smsModel.service_type = template.service_type;
        this.grupos = template.groups;
    }

    onChangeHideMessage(event) {
        this.hideMessage = event.checked;
    }

    hasUrl(event) {
        if (event.checked) {
            this.hasURL = true;
            this.smsForm.controls["longUrl"].setValidators([
                Validators.required,
            ]);
        } else {
            this.hasURL = false;
            this.smsForm.controls["longUrl"].clearValidators();
            this.smsForm.controls["longUrl"].updateValueAndValidity();
        }
    }

    createForm() {
        const form = new FormGroup({
            name: new FormControl(this.smsModel.name),
            service_type: new FormControl({
                value: this.smsModel.service_type,
                disabled: true,
            }),
            msisdn: new FormControl(this.smsModel.msisdn),
            message: new FormControl(this.smsModel.message),
            shortcode: new FormControl(this.smsModel.shortCode),
            grupo: new FormControl({
                value: this.smsModel.groups,
                disabled: true,
            }),
            template: new FormControl(this.smsModel.template_id),
            longUrl: new FormControl({
                value: this.smsModel.longUrl,
                disabled: true,
            }),
            validityPeriod: new FormControl(this.smsModel.validityPeriod),
        });

        if (this.templateSelected) {
            form.controls["shortcode"].disable();
            form.controls["message"].disable();
        }

        form.controls["name"].valueChanges.subscribe(
            (value) => (this.smsModel.name = value)
        );

        form.controls["msisdn"].valueChanges.subscribe((value) => {
            this.smsModel.msisdn = value;
        });

        form.controls["message"].valueChanges.subscribe(
            (value) => (this.smsModel.message = value)
        );

        form.controls["shortcode"].valueChanges.subscribe((value) => {
            this.smsModel.shortCode = value;
        });
        form.controls["grupo"].valueChanges.subscribe(
            (value) => (this.smsModel.groups = value)
        );

        form.controls["longUrl"].valueChanges.subscribe((value) => {
            this.smsModel.longUrl = value;
        });

        form.controls["validityPeriod"].valueChanges.subscribe((value) => {
            this.smsModel.validityPeriod = value;
        });

        return form;
    }

    compareFn(op1: any, op2: any) {
        if (op2 === null || op2 === undefined) {
            return;
        }
        return op1.id === op2.id;
    }

    performAction() {
        if (this.smsForm.invalid) {
            return;
        }
        this.isWaiting = true;

        this.smsModel = {
            ...this.smsModel,
            ...this.smsForm.value,
            message: this.smsForm.controls.message.value,
            obfuscated_message: this.hashMessage(
                this.smsForm.controls.message.value
            ),
            obfuscated: this.hideMessage,
        };

        if (!isArray(this.smsForm.controls.msisdn.value)) {
            this.smsModel.msisdn = [this.smsForm.controls.msisdn.value];
        }

        this.callback(this.smsModel);
    }

    private hashMessage(message: string) {
        if (!this.hideMessage) {
            return null;
        }
        const saltRounds = 10;
        const salt = bcrypt.genSaltSync(saltRounds);
        return bcrypt.hashSync(message, salt);
    }

    radioGrupoChange(event: any) {
        switch (event.value) {
            case "2":
                this.templateSelected = false;
                this.hasURL = false;
                this.smsForm.controls["msisdn"].setValidators(
                    Validators.required
                );
                this.smsForm.controls["grupo"].clearValidators();
                this.smsForm.controls["grupo"].setValue(null);
                this.smsForm.controls["template"].setValue(null);
                this.smsForm.controls["message"].setValue(null);

                this.smsForm.controls["grupo"].updateValueAndValidity();
                this.smsModel.groups = new Array<Grupo>();
                this.smsForm.controls["shortcode"].enable();
                this.smsForm.controls["shortcode"].setValue(null);
                this.smsForm.controls["longUrl"].setValue(null);

                this.smsForm.controls["message"].enable();
                this.smsForm.controls["longUrl"].enable();

                break;

            default:
                this.templateSelected = true;
                this.hasURL = false;
                this.smsForm.controls["shortcode"].disable();
                this.smsForm.controls["message"].disable();
                this.smsForm.controls["longUrl"].disable();
                this.smsForm.controls["longUrl"].setValue(null);

                this.smsTemplateService.getTemplates().subscribe((res) => {});
                this.smsForm.controls["grupo"].setValidators(
                    Validators.required
                );
                this.smsForm.controls["msisdn"].clearValidators();
                this.smsForm.controls["msisdn"].setValue(null);
                this.smsForm.controls["msisdn"].updateValueAndValidity();
                this.smsModel.msisdn = new Array<string>();
                break;
        }
    }
}
